import Vue from 'vue'
import VueRouter from 'vue-router'
import home1 from '../views/home1.vue'
import About from '../views/About.vue'
import doctorProduct from '../views/doctorProduct.vue'
import Survey from '../views/Survey.vue'
import news from '../views/news.vue'
import notice from '../views/notice.vue'
import party from '../views/party.vue'
import office from '../views/office.vue'
import fingerpost from '../views/fingerpost.vue'
import doctor from '../views/doctor.vue'
import doctorList from '../views/doctorList.vue'
import administrative from '../views/administrative.vue'
import administrativeDetail from '../views/administrativeDetail.vue'
import body from '../views/body.vue'
import bodyS from '../views/body1.vue'
import leadership from '../views/leadership.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home1',
    component: home1,
    children: [
      {
        path: '/',
        name: 'About',
        component: About,
      },
      {
        path: 'Survey',
        name: 'Survey',
        component: Survey
      },
      {
        path: 'news',
        name: 'news',
        component: news
      },
      {
        path: 'notice',
        name: 'notice',
        component: notice
      },
      {
        path: 'medicine',
        name: 'medicine',
        component: doctorProduct
      },
      {
        path: 'party',
        name: 'party',
        component: party
      },
      {
        path: 'office',
        name: 'office',
        component: office
      },
      {
        path: 'fingerpost',
        name: 'fingerpost',
        component: fingerpost
      },
      {
        path: 'doctor',
        name: 'doctor',
        component: doctor
      },
      {
        path: 'doctorList',
        name: 'doctorList',
        component: doctorList
      },
      {
        path: 'administrative',
        name: 'administrative',
        component: administrative
      },
      {
        path: 'administrativeDetail',
        name: 'administrativeDetail',
        component: administrativeDetail
      },
      {
        path: 'body',
        name: 'body',
        component: body
      }
      ,
      {
        path: 'bodyS',
        name: 'bodyS',
        component: bodyS
      }
      ,
      {
        path: 'leadership',
        name: 'leadership',
        component: leadership
      }
    ]
  }

  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

export default router
